import { render, staticRenderFns } from "./bankSet.vue?vue&type=template&id=458a3014&scoped=true"
import script from "./bankSet.vue?vue&type=script&lang=js"
export * from "./bankSet.vue?vue&type=script&lang=js"
import style0 from "./bankSet.vue?vue&type=style&index=0&id=458a3014&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458a3014",
  null
  
)

export default component.exports